"use client";
import React from "react";
import Link from "next/link";
import styles from "./General.module.css";
import { routes } from "@/utils/routes";
import { useAuthContext } from "@wayak/auth/hooks/auth-hook";
import { authRoutes } from "@wayak/auth/utils/routes";

const menuItems = [
  // { label: "AI Academy", href: "#" },
  // { label: "Pricing", href: "#" },
  {
    label: "Contact",
    href: "https://s0noz.share.hsforms.com/2GWLXC5fySh20b7utDLgc9Q",
  },
];

export default function CustomHeader() {
  const { user } = useAuthContext();
  return (
    <header
      className={`absolute  w-full flex-col md:flex-row flex items-center justify-between px-2 md:px-8 py-4`}
      style={{ zIndex: 50 }}
    >
      <div className="flex w-full justify-center md:w-auto mb-4 md:mb-0 items-center">
        <Link href="/">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src="/synergy/wayak-logo.png"
            alt="Wayak Logo"
            className="w-28 h-6"
          />
        </Link>
      </div>
      <nav
        className={`flex items-center gap-2 md:gap-4 bg-[#232323]/80 rounded-full px-4 py-2 ${styles.navFloat}`}
      >
        {menuItems.map((item) => (
          <Link
            key={item.label}
            href={item.href}
            className="text-white px-3 py-1 rounded-md hover:bg-[#232323]/60 transition-colors text-xs md:text-sm font-medium"
          >
            {item.label}
          </Link>
        ))}
        {user ? (
          <Link
            href={routes.personalDashboard}
            className="bg-[#FF2D2D] text-white px-4 py-1 rounded-full font-semibold text-xs md:text-sm hover:bg-[#e32626] transition-colors ml-2"
          >
            Dashboard
          </Link>
        ) : (
          <>
            {/* <Link
              href={authRoutes.auth.signUp}
              className="bg-[#FF2D2D] text-white px-4 py-1 rounded-full font-semibold text-xs md:text-sm hover:bg-[#e32626] transition-colors ml-2"
            >
              Get started
            </Link> */}
            <Link
              href={authRoutes.auth.login}
              className="text-white px-3 py-1 rounded-md hover:bg-[#232323]/60 transition-colors text-xs md:text-sm font-medium"
            >
              Log in
            </Link>
          </>
        )}
      </nav>
    </header>
  );
}
